import { FunctionalComponent } from 'preact'

/**
 * @deprecated
 * Use `<Button variant='text' />` instead
 */
const TextButton: FunctionalComponent<JSX.HTMLAttributes> = (props) => {
  return (
    <button
      {...props}
      type='button'
      style={{
        background: 'none',
        border: 'none',
        fontWeight: 'inherit',
        display: 'inline-block',
        padding: 0,
        margin: 0,
        cursor: 'pointer',
        ...props.style
      }}
    >
      {' '}
      {props.children}
    </button>
  )
}

export default TextButton
